import React from "react";
import styled from "styled-components";
import { useTrainingStore } from "../../stores/trainingStore";

const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 20px;
`;

const SettingCard = styled.div`
  background: var(--card-bg);
  padding: 15px;
  border-radius: 20px;
  h3 {
    font-size: 0.9rem;
    color: var(--text-sub);
    margin-bottom: 10px;
    text-align: center;
  }
`;

const InputGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  input {
    width: 50px;
    background: #000;
    border: 1px solid #333;
    color: white;
    padding: 8px;
    border-radius: 8px;
    text-align: center;
    font-size: 1rem;
  }
`;

export const IntervalSettings: React.FC = () => {
  const { settings, setSettings } = useTrainingStore();
  const update = (field: string, val: number) =>
    setSettings({ ...settings, [field]: val });

  return (
    <SettingsGrid>
      <SettingCard>
        <h3>🏃 RUN</h3>
        <InputGroup>
          <input
            type="number"
            value={settings.runMinutes}
            onChange={(e) => update("runMinutes", +e.target.value)}
          />
          <span>m</span>
          <input
            type="number"
            value={settings.runSeconds}
            onChange={(e) => update("runSeconds", +e.target.value)}
          />
          <span>s</span>
        </InputGroup>
      </SettingCard>
      <SettingCard>
        <h3>🚶 WALK</h3>
        <InputGroup>
          <input
            type="number"
            value={settings.walkMinutes}
            onChange={(e) => update("walkMinutes", +e.target.value)}
          />
          <span>m</span>
          <input
            type="number"
            value={settings.walkSeconds}
            onChange={(e) => update("walkSeconds", +e.target.value)}
          />
          <span>s</span>
        </InputGroup>
      </SettingCard>
    </SettingsGrid>
  );
};
